import { ModuleWithProviders, NgModule } from '@angular/core';
import { INVENTORY_ROUTE_PROVIDERS } from './providers/route.provider';
import { EQUIPMENTS_EQUIPMENT_ROUTE_PROVIDER } from './providers/equipment-route.provider';
import { PROVIDERS_PROVIDER_ROUTE_PROVIDER } from './providers/provider-route.provider';
import { LOCATIONS_LOCATION_ROUTE_PROVIDER } from './providers/location-route.provider';
import { ASSET_TYPES_ASSET_TYPE_ROUTE_PROVIDER } from './providers/asset-type-route.provider';
import { ASSET_STATE_TYPES_ASSET_STATE_TYPE_ROUTE_PROVIDER } from './providers/asset-state-type-route.provider';
import { EVENT_TYPES_EVENT_TYPE_ROUTE_PROVIDER } from './providers/event-type-route.provider';
import { ASSETS_ASSET_ROUTE_PROVIDER } from './providers/asset-route.provider';

@NgModule()
export class InventoryConfigModule {
  static forRoot(): ModuleWithProviders<InventoryConfigModule> {
    return {
      ngModule: InventoryConfigModule,
      providers: [INVENTORY_ROUTE_PROVIDERS, EQUIPMENTS_EQUIPMENT_ROUTE_PROVIDER, PROVIDERS_PROVIDER_ROUTE_PROVIDER, LOCATIONS_LOCATION_ROUTE_PROVIDER, ASSET_TYPES_ASSET_TYPE_ROUTE_PROVIDER, ASSET_STATE_TYPES_ASSET_STATE_TYPE_ROUTE_PROVIDER, EVENT_TYPES_EVENT_TYPE_ROUTE_PROVIDER, ASSETS_ASSET_ROUTE_PROVIDER],
    };
  }
}
